import React, {useMemo} from 'react';
import _get from 'lodash/get';
import GhostContentAPI, { GhostAPI } from '@tryghost/content-api';

function withContentApi<IProps>(Component: React.FC<IProps>) {
  return (
    props: IProps
  ) => {
    const api: GhostAPI|null = useMemo(() => {
      const url =  _get(process.env, 'REACT_APP_GHOST_API_URL', '');
      const key =  _get(process.env, 'REACT_APP_GHOST_API_KEY', '');

      if(!url || !key) {
        return null;
      }

      try {
       return new GhostContentAPI({
          url,
          key,
          version: 'v3'
        });
      } catch(error) {
        console.error(error);
        return null;
      }
    }, [])
  
    return <Component { ...props } api={api} />
  };
}

export default withContentApi;
